import { render } from "./LocationString.vue?vue&type=template&id=2d95a9a2&scoped=true"
import script from "./LocationString.vue?vue&type=script&lang=js"
export * from "./LocationString.vue?vue&type=script&lang=js"

import "./LocationString.vue?vue&type=style&index=0&id=2d95a9a2&lang=css"
import "./LocationString.vue?vue&type=style&index=1&id=2d95a9a2&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d95a9a2"]])

export default __exports__